export default "__VITE_ASSET__DsiwNG5W__"